module.exports = __webpack_public_path__ + "BF.png?82e7a1da23117e2c7274438f473e5df1";